type AuthErrorLike = {
  code?: string | null;
  message?: string | null;
  status?: number;
};

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (email: string): boolean => EMAIL_PATTERN.test(email.trim());

export const getEmailValidationKey = (email: string): string | null => {
  if (!email.trim()) return 'errors.emailRequired';
  if (!isValidEmail(email)) return 'errors.emailInvalid';
  return null;
};

export const getAuthErrorTranslationKey = (
  error: unknown,
  fallbackKey = 'errors.generic'
): string => {
  const authError = error as AuthErrorLike;
  const code = authError?.code ?? '';
  const message = (authError?.message ?? '').toLowerCase();

  switch (code) {
    case 'invalid_credentials':
      return 'login.invalid_credentials';
    case 'email_not_confirmed':
      return 'login.email_not_confirmed';
    case 'email_address_invalid':
    case 'validation_failed':
      return 'errors.emailInvalid';
    case 'user_already_exists':
    case 'email_exists':
      return 'emailTakenException';
    case 'over_email_send_rate_limit':
      return 'errors.emailRateLimited';
    default:
      break;
  }

  if (message.includes('email') && (message.includes('invalid') || message.includes('validate'))) {
    return 'errors.emailInvalid';
  }
  if (message.includes('already') || message.includes('registered')) {
    return 'emailTakenException';
  }
  if (message.includes('rate limit') || message.includes('too many')) {
    return 'errors.emailRateLimited';
  }

  return fallbackKey;
};
